//language, slider, contact,
// about, partner, category,
// joinUs, brandType, subscriber,
// staticTexts, blog, filter, brand,
// product, badge, moderator, file


export const ACCESS_PAGES = {
    moderators: {
        key: 'moderators',
        name: 'Մոդերատորներ',
        icon: 'supervised_user_circle',
        crud: false,
        isHidden: false,
    },
    products: {
        key: 'product',
        name: 'Ապրանքներ',
        icon: 'add_shopping_cart',
        crud: true,
        isHidden: true,
    },
    media: {
        key: 'file',
        name: 'Ֆայլեր',
        icon: 'filter',
        crud: true,
        isHidden: false,
    },
    slider: {
        key: 'slider',
        name: 'Սլայդեր',
        icon: 'amp_stories',
        crud: true,
        isHidden: false,
    },
    partners: {
        key: 'partner',
        name: 'Գործընկերներ',
        icon: 'group_work',
        grouped:['joinUs'],
        crud: true,
        isHidden: false,
    },
    categories: {
        key: 'category',
        name: 'Կատեգորիաներ',
        icon: 'category',
        crud: true,
        isHidden: false,
    },
    brand: {
        key: 'brand',
        name: 'Բրենդ',
        icon: 'receipt',
        crud: true,
        isHidden: false,
    },
    brandTypes: {
        key: 'brandType',
        name: 'Բրենդի տեսակներ',
        icon: 'scatter_plot',
        crud: true,
        isHidden: false,
    },
    filters: {
        key: 'filter',
        name: 'Ֆիլտրեր',
        icon: 'style',
        crud: true,
        isHidden: false,
    },
    badges: {
        key: 'badge',
        name: 'Պիտակներ',
        icon: 'loyalty',
        crud: true,
        isHidden: false,
    },
    blogs: {
        key: 'blog',
        name: 'Բլոգ',
        icon: 'import_contacts',
        crud: true,
        isHidden: false,
    },
    about: {
        key: 'about',
        name: 'Մեր մասին',
        icon: 'calendar_view_day',
        crud: true,
        isHidden: false,
    },
    contact: {
        key: 'contact',
        name: 'Կապ',
        icon: 'contact_phone',
        crud: true,
        isHidden: false,
    },
    subscribe: {
        key: 'subscriber',
        name: 'Բաժանորդներ',
        icon: 'supervisor_account',
        crud: true,
        isHidden: false,
    },
    languages: {
        key: 'language',
        name: 'Լեզուներ',
        icon: 'language',
        crud: true,
        isHidden: false,
    },
    staticTexts: {
        key: 'staticTexts',
        name: 'Թարգմանություններ',
        icon: 'text_format',
        crud: true,
        isHidden: false,
    },



    // users: {
    //     key: 'USERS',
    //     name: 'Օգտատերեր',
    //     icon: 'person',
    //     crud: true,
    //     isHidden: false,
    // },
    // orders: {
    //     key: 'ORDERS',
    //     name: 'Պատվերներ',
    //     icon: 'notes',
    //     crud: true,
    //     isHidden: false,
    // },
    // banner: {
    //     key: 'BANNERS',
    //     name: 'Զեղչեր',
    //     icon: 'redeem',
    //     crud: true,
    //     isHidden: false,
    // },
    // section: {
    //     key: 'SECTIONS',
    //     name: 'Բաժիններ',
    //     icon: 'vertical_split',
    //     crud: true,
    //     isHidden: false,
    // },
    // status: {
    //     key: 'ORDER_STATUSES',
    //     name: 'Կարգավիճակ',
    //     icon: 'payments',
    //     crud: true,
    //     isHidden: false,
    // },
    // promoCodes: {
    //     key: 'PROMO_CODES',
    //     name: 'Զեղչի կոդեր',
    //     icon: 'card_giftcard',
    //     crud: true,
    //     isHidden: false,
    // },
    // blogTypes: {
    //     key: 'BLOG_TYPE',
    //     name: 'Բլոգի տեսակներ',
    //     icon: 'library_add_check',
    //     crud: true,
    //     isHidden: false,
    // },
    // customPages: {
    //     key: 'CUSTOM_PAGES',
    //     name: 'Դինամիկ էջեր',
    //     icon: 'web',
    //     crud: true,
    //     isHidden: false,
    // },
    // notifications: {
    //     key: 'NOTIFICATIONS',
    //     name: 'notifications',
    //     icon: 'notifications',
    //     crud: true,
    //     isHidden: true,
    // },
    // settings: {
    //     key: 'SETTINGS',
    //     name: 'Կարգավորումներ',
    //     icon: 'settings',
    //     crud: false,
    //     isHidden: true,
    // },
};
